import { Autocomplete, Box, Chip, TextField } from "@mui/material"
import { isNil } from "lodash"
import { useState } from "react"
import Barinade from "../../core/assets/oot/boss/OoT_Barinade.png"
import Bongo from "../../core/assets/oot/boss/OoT_Bongo_Bongo.png"
import Ghoma from "../../core/assets/oot/boss/OoT_Gohma.png"
import KingDodong from "../../core/assets/oot/boss/OoT_King_Dodongo.png"
import Morpha from "../../core/assets/oot/boss/OoT_Morpha.png"
import PhantomGanon from "../../core/assets/oot/boss/OoT_Phantom_Ganon.png"
import Twinrova from "../../core/assets/oot/boss/OoT_Twinrova.png"
import Volvagia from "../../core/assets/oot/boss/OoT_Volvagia.png"

export interface BossDto {
    name: string,
    tags: Array<string>,
    img: string
}
const bossData: Array<BossDto> = [
    { name: "Ghoma", tags: ["Spider", "Deku"], img: Ghoma },
    { name: "KD", tags: ["KD", "Goron"], img: KingDodong },
    { name: "Bari", tags: ["Bari", "Chateau"], img: Barinade },
    { name: "PG", tags: ["PG", "Forest"], img: PhantomGanon },
    { name: "Volvi", tags: ["KAK", "Cocorico"], img: Volvagia },
    { name: "Morpha", tags: ["Tentacule", "Eau"], img: Morpha },
    { name: "Bongo", tags: ["BB", "Bongo"], img: Bongo },
    { name: "Twin", tags: ["TR", "Sorciere"], img: Twinrova },
]

interface BossAutocompleteProps {
    value?: BossDto | null,
    setValue?: (v: BossDto | null) => void
}

const BossAutocomplete = (props: BossAutocompleteProps) => {


    let [boss, setBoss] = useState<BossDto | null>(null)


    let value =  !isNil(props.setValue) ? props.value : boss
    let setValue = !isNil(props.setValue) ? props.setValue : setBoss
    if (!isNil(boss))
        return <Box onContextMenu={() => setValue(null)} display="flex" alignItems="center">
            <img src={value?.img} alt={value?.name} height={"27"} width={"38px"} />
            {value?.name}
        </Box>
    return <Autocomplete
        options={bossData}
        
        renderInput={(props) => <TextField
            {...props}
            size="small"
            variant="standard"
        />}
        renderTags={(values) =>
            values.map((value) => (
                <Chip
                    label={value.name}
                    icon={<img src={value.img} alt={value.name} height={30} width={30} />}
                />
            ))
        }
        renderOption={(props, option, state) => {
            return (
                <li {...props}>
                    <img src={option.img} alt={option.name} height={30} width={30} />
                    {option.name}
                </li>
            )
        }}
        onChange={(e, v) => setValue(v)}
        value={value}
        getOptionLabel={(o) => o.name}
        filterOptions={(o, v) => o.filter(x => x.name.toLowerCase().includes(v.inputValue.toLowerCase()) || x.tags.some(t => t.toLowerCase().includes(v.inputValue.toLowerCase())))}
        sx={{ width: "170px" }}
        size='small'
    />
}

export default BossAutocomplete